import MUICardContent from '@mui/material/CardContent';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const CardContent = styled(MUICardContent)`
	padding: ${({ theme }) => theme.spacing(3)};
`;
